// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';

export default function(state = {}, action) {
  const typeMap = {
    POST_MORE_STORIES_LOADING() {
      return {
        isLoading: true,
        postMoreStories: action.postMoreStories
      };
    },
    POST_MORE_STORIES_LOADED() {
      return {
        isLoading: false,
        data: action.postMoreStories
      };
    },
    POST_MORE_STORIES_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.postMoreStories.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
